'use client';
export { FlashList as FlatList } from '@shopify/flash-list';
